<script setup>
import { Link } from '@inertiajs/vue3';
import Icon from '@/Components/Icon.vue';

defineProps({
    items: {
        type: Array,
        required: true,
    },
    close: {
        type: Function,
        required: true,
    },
});
</script>

<template>
    <div
        v-for="(submenu, index) in items"
        :key="index"
    >
        <div
            v-if="submenu.title"
            class="text-xl"
        >
            {{ submenu.title }}
        </div>

        <ul class="grid grid-cols-4 gap-x-16 gap-y-8">
            <li
                v-for="(subitem, sindex) in submenu.children"
                :key="sindex"
            >
                <Link
                    :href="subitem.permalink || ''"
                    class="inline-flex items-center text-lg hover:text-sunset-orange-500 focus:text-sunset-orange-500 outline-hidden"
                    :class="{ 'text-sunset-orange-500': subitem.is_current }"
                    @click="close"
                >
                    <Icon
                        v-if="subitem.icon"
                        class="shrink-0 h-10 w-10 mr-4 opacity-75"
                        aria-hidden="true"
                        :icon="{ svg: subitem.icon }"
                    />

                    {{ subitem.title }}
                </Link>
            </li>
        </ul>
    </div>
</template>
